(function () {
    angular.module('tmx-app')
        .controller('userLimitManagementEditCtrl', ['$state','tmxUtility', 'resolvedData', 'UserLimitManagementService', 'BranchService', 'ToastService',

            function UserLimitManagementEditCtrl($state,tmxUtility, resolvedData, UserLimitManagementService, BranchService, ToastService) {
                
                //#region  =========== Variables and Declarations =============================

                var userLimitVM = this;
                var exists = tmxUtility.exists;
                userLimitVM.isReadOnly = false;
                userLimitVM.isEdit = false;
                userLimitVM.companiesList = [];
                userLimitVM.rolesList = [];
                userLimitVM.usersList = [];
                userLimitVM.userTypes =[];
                userLimitVM.branchList =[];
                userLimitVM.productList = [];


                //#endregion

                //#region ============ Scope Functions =======================================

                userLimitVM.onUserSelected=function(userId){
                    let selectedUser = userLimitVM.usersList.find(x=>x.HiddenValue == userId);
                    if(exists(selectedUser)){
                        userLimitVM.vm.FullName = selectedUser.FullName;
                        userLimitVM.vm.RoleID = selectedUser.RoleID;
                    }
                    else{
                        userLimitVM.vm.FullName = null;
                        userLimitVM.vm.RoleID = null;
                    }
                }

                userLimitVM.onCompanySelected = function(companyId){
                    if(!exists(companyId)){
                        userLimitVM.branchList = [];
                        userLimitVM.vm.CompanyBranchId = null;
                        return;
                    }
                    BranchService.CompanyBranchLov(companyId).then(
                        function (data) {
                            userLimitVM.branchList = data.data;
                        }
                    );
                }

                userLimitVM.cancel = function () {
                    $state.searchClear = true;
                    $state.go("^");
                };

                userLimitVM.save = function(form){
                    form.$submitted = true;
                    if(form.$invalid){
                        userLimitVM.formInvalid = true;
                        ToastService.showCustomToast("error", "Please fill required information to continue.");
                        return;
                    }
                    userLimitVM.loading = true;
                    UserLimitManagementService.SaveLimitData(userLimitVM.vm).then(function(response){
                        if(response.status.code ==200){
                            $state.searchClear = true;
                            $state.go("^");
                        }
                        else{
                            ToastService.showCustomToast("error", "Error in saving limit information");
                        }
                    });
                }

                //#endregion

                //#region ============ Local / Private Functions ==============================

                function setFormEditState(){
                    userLimitVM.isEdit =true;
                }
                function setFormAddState(){
                    userLimitVM.isEdit= false;
                    userLimitVM.usersList = userLimitVM.usersList.filter(filterActiveUsers);
                    console.log(userLimitVM.usersList.length);
                }
                function handleResolveData(){
                    if(exists(resolvedData.UsersList.data)){
                        userLimitVM.usersList = resolvedData.UsersList.data.map(x=>(
                            {
                                VisibleValue: x.UserName,
                                HiddenValue:x.UserID,
                                Status:x.Status,
                                RoleID:x.RoleID,
                                FullName: [x.FirstName,x.MiddleName,x.LastName].join(' ')
                            }));
                        console.log(userLimitVM.usersList.length);

                    }
                    if(exists(resolvedData.RoleLov.data)){
                        userLimitVM.rolesList = resolvedData.RoleLov.data;
                    }
                    if(exists(resolvedData.Company.data)){
                        userLimitVM.companiesList = resolvedData.Company.data;
                    }
                    if(exists(resolvedData.ActiveProducts)){
                        userLimitVM.productList = resolvedData.ActiveProducts.map(x=>(
                            {
                                VisibleValue:x.ProductName,
                                HiddenValue:x.ProductId
                            }
                        ));
                    }
                    if(exists(resolvedData.UserTypes)){
                        userLimitVM.userTypes = resolvedData.UserTypes;
                    }
                    if(exists(resolvedData.LoanLimit.data)){
                        //Edit case
                        populateDataForEdit(resolvedData.LoanLimit.data)
                        setFormEditState();
                    }
                    else {
                        // Add case
                        userLimitVM.vm = {};
                        setFormAddState();
                    }

                }

                function populateDataForEdit(data){
                    userLimitVM.vm = data ;
                    if(exists(userLimitVM.vm.UserID)){
                        userLimitVM.onUserSelected(userLimitVM.vm.UserID);
                    }
                    if(exists(userLimitVM.vm.CompanyBranchID)){
                        BranchService.getCompanyByBranchId(userLimitVM.vm.CompanyBranchID)
                            .then(function (data) {
                                if (angular.isDefined(data)) {
                                    userLimitVM.vm.CompanyId = data.data.CompanyId;
                                }
                            });
                    }
                }
                

                function filterActiveUsers(user){
                    if(exists(user.Status)){
                        return user.Status.toLowerCase() == 'active';
                    }
                    return false;
                }

                function initializeData(){
                    if(userLimitVM.companiesList.length ==1){
                        userLimitVM.vm.CompanyId = userLimitVM.companiesList.HiddenValue;
                        userLimitVM.onCompanySelected(userLimitVM.vm.CompanyId);
                    }
                }

                //#endregion

                (function InitializePage(){
                    handleResolveData();
                    initializeData();
                })();


            }]);
})();
